export const VisageComponentSymbol = '@@vsg';
